var _rect, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": "uTranscribe logo",
    viewBox: "0 0 64 64"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "#6f42c1",
    rx: 12
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 32,
    y: 42,
    fill: "#fff",
    fontFamily: "Arial, sans-serif",
    fontSize: 32,
    fontWeight: 700,
    textAnchor: "middle"
  }, "u")));
};
export default SvgLogo;